import axios from "axios";

const request = axios.create({
  baseURL: "/",
  timeout: 5000,
});

request.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.log(error);
    }
    return Promise.reject(error.response.data);
  }
);

export { request };
